export enum Column {
  Status = 'Status',
  Date = 'Date',
  Value = 'Value',
  Action = 'Action'
}
